import ImageGallery, { ImageGalleryProps } from './imageGallery'

// No logic — passthrough kept for the two-file pattern; containers resolve labels.
const ImageGalleryWrapper = (props: ImageGalleryProps) => {
    return <ImageGallery {...props} />
}

export { ImageGalleryWrapper }
export type { ImageGalleryProps }
export default ImageGalleryWrapper
